import { render, staticRenderFns } from "./controleSocietes.vue?vue&type=template&id=2afd4f19"
import script from "./controleSocietes.vue?vue&type=script&lang=js"
export * from "./controleSocietes.vue?vue&type=script&lang=js"
import style0 from "./controleSocietes.vue?vue&type=style&index=0&id=2afd4f19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports